import { computed, inject, Injectable, signal } from "@angular/core";
import { rxResource } from "@angular/core/rxjs-interop";
import {
    EnrollmentScheduleDto,
    ScheduleLogService,
} from "@malirang/api-client";
import { DocumentStatus } from "@malirang/common";
import { injectQueryParams } from "ngxtension/inject-query-params";
import { CenterStore } from "../../../../../stores/center/center.store";

type State = {
    cursor?: string | null;
    hasNext?: boolean;
    items?: EnrollmentScheduleDto[];
    query?: string;
    totalCount?: number;
    startAt?: Date | null;
    endAt?: Date | null;
    status?: keyof typeof DocumentStatus | "ALL";
};

@Injectable({ providedIn: "root" })
export class ScheduleLogStore {
    private readonly service = inject(ScheduleLogService);
    private readonly ticketId = injectQueryParams("ticketId");
    private readonly centerStore = inject(CenterStore);

    private _cursor = signal<string | null>(null);
    private _hasNext = signal<boolean>(false);
    private _startAt = signal<Date | null>(null);
    private _endAt = signal<Date | null>(null);

    cursor = computed(() => this._cursor());
    hasNext = computed(() => this._hasNext());
    startAt = computed(() => this._startAt());
    endAt = computed(() => this._endAt());

    $schedules = rxResource({
        params: () => ({
            ticketId: this.ticketId()!,
            centerId: this.centerStore.currentCenterId(),
            startDate: this.startAt()?.toISOString(),
            endDate: this.endAt()?.toISOString(),
        }),
        stream: ({ params }) =>
            this.service.scheduleLogControllerSearch({
                ticketId: params.ticketId,
                startDate: params.startDate || "",
                endDate: params.endDate || "",
            }),
    });
    items = computed(() =>
        this.$schedules.hasValue() ? this.$schedules.value() : [],
    );

    setState(statue: Partial<State>) {
        if (statue.cursor !== undefined) {
            this._cursor.set(statue.cursor);
        }

        if (statue.hasNext !== undefined) {
            this._hasNext.set(statue.hasNext);
        }

        if (statue.startAt !== undefined) {
            this._startAt.set(statue.startAt);
        }

        if (statue.endAt !== undefined) {
            this._endAt.set(statue.endAt);
        }
    }
}
